// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/drag.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/drag/drag.js';

mount([g0]);
